import React, { useEffect, useState } from "react";

const GUNLER = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
const pick = (t) => ({ yemek_yok: !!t.yemek_yok, yol_yok: !!t.yol_yok, calisma_gunleri: t.calisma_gunleri || [], yarim_gunler: t.yarim_gunler || [] });
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const PositionRulesRow = ({ t, isAdmin, busy, onSave, onClearPersonal }) => {
  const [draft, setDraft] = useState(pick(t));
  const key = JSON.stringify(pick(t));
  useEffect(() => { setDraft(JSON.parse(key)); }, [key]);
  const orig = pick(t);
  const dirty = !same(draft, orig);
  const { calisma_gunleri: days, yarim_gunler: half } = draft;

  const toggleDay = (d) => {
    let full = days.filter((x) => x !== d);
    let yarim = half.filter((x) => x !== d);
    if (!days.includes(d) && !half.includes(d)) full = [...full, d].sort();
    else if (days.includes(d)) yarim = [...yarim, d].sort();
    setDraft({ ...draft, calisma_gunleri: full, yarim_gunler: yarim });
  };
  const save = () => {
    const patch = Object.fromEntries(Object.entries(draft).filter(([k, v]) => !same(v, orig[k])));
    if (patch.calisma_gunleri || patch.yarim_gunler) Object.assign(patch, { calisma_gunleri: days, yarim_gunler: half });
    const parts = [];
    if ("yemek_yok" in patch) parts.push(`yemek ücreti ${draft.yemek_yok ? "yok" : "var"}`);
    if ("yol_yok" in patch) parts.push(`yol ücreti ${draft.yol_yok ? "yok" : "var"}`);
    if (patch.calisma_gunleri) {
      const l = [...days.map((x) => GUNLER[x]), ...half.map((x) => `${GUNLER[x]}½`)];
      parts.push(l.length ? `çalışma günleri: ${l.join(" ")}` : "çalışma günleri şablona döndü");
    }
    onSave(t, patch, parts.join(" · "));
  };
  const chk = (field, label, testid) => (
    <label className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded border ${draft[field] ? "bg-rose-50 border-rose-300 text-rose-800" : "bg-white border-slate-200 text-slate-600"}`}
      title={isAdmin ? "" : "Yalnızca Admin değiştirebilir"}>
      <input type="checkbox" checked={draft[field]} disabled={!isAdmin || busy} data-testid={`${testid}-${t.id}`}
        onChange={(e) => setDraft({ ...draft, [field]: e.target.checked })} />
      {label}
    </label>
  );
  return (
    <div className="mt-2 flex items-center gap-2 flex-wrap pl-9" data-testid={`ptm-rules-${t.id}`}>
      {chk("yemek_yok", "Yemek ücreti yok", "ptm-yemek-yok")}
      {chk("yol_yok", "Yol ücreti yok", "ptm-yol-yok")}
      <span className="text-[10px] font-semibold text-slate-500 ml-2">Çalışma günleri:</span>
      <div className="inline-flex gap-0.5">
        {GUNLER.map((g, i) => (
          <button key={g} type="button" disabled={busy} onClick={() => toggleDay(i)} data-testid={`ptm-day-${t.id}-${i}`}
            title="Tıkla: tam gün → yarım gün → kapalı"
            className={`text-[10px] font-bold w-9 py-0.5 rounded transition-colors ${days.includes(i) ? "bg-teal-700 text-white" : half.includes(i) ? "bg-teal-100 text-teal-800 border border-teal-400" : "bg-white border border-slate-200 text-slate-500 hover:bg-slate-100"}`}>
            {g}{half.includes(i) ? "½" : ""}</button>
        ))}
      </div>
      {dirty && (
        <>
          <button type="button" disabled={busy} onClick={save} data-testid={`ptm-rules-save-${t.id}`}
            className="text-[11px] font-semibold px-2 py-1 bg-teal-700 hover:bg-teal-800 text-white rounded">Önizle & Kaydet</button>
          <button type="button" disabled={busy} onClick={() => setDraft(orig)} data-testid={`ptm-rules-reset-${t.id}`}
            className="text-[11px] font-semibold px-2 py-1 text-slate-600 hover:bg-slate-100 rounded">Geri Al</button>
        </>
      )}
      {!days.length && !half.length && <span className="text-[10px] text-slate-400">seçilmezse çalışma şablonu / Pzt–Cum</span>}
      {half.length > 0 && <span className="text-[10px] text-teal-700">½ = yarım gün · puantajda tam gün, tam yemek</span>}
      {t.override_count > 0 && (
        <span className="text-[10px] text-amber-800 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5" data-testid={`ptm-override-${t.id}`}>
          {t.override_count} personelde kişiye özel çalışma şablonu var (pozisyon günlerini ezer)
          <button type="button" disabled={busy} onClick={() => onClearPersonal(t)} data-testid={`ptm-clear-personal-${t.id}`}
            className="ml-1 font-bold underline hover:text-amber-950">Pozisyona bağla</button>
        </span>
      )}
    </div>
  );
};
